import { render, staticRenderFns } from "./QsaList.vue?vue&type=template&id=f8358b72"
import script from "./QsaList.vue?vue&type=script&lang=js"
export * from "./QsaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports